import ScopeType from '@/utils/enums/ScopeType';
import { addSpacing } from 'utils/utils';

export const canEditPermission = (data, requiredScope, currentCompany) => {
    const canEditCondition = (scope) =>
        !(
            !data?.companyID ||
            data?.requiredScope > scope ||
            data?.companyID !== currentCompany
        );
    switch (requiredScope) {
        case ScopeType.COMPANY:
            return canEditCondition(ScopeType.COMPANY);
        case ScopeType.PARTNER:
            return canEditCondition(ScopeType.PARTNER);
        case ScopeType.WHOLESALER:
            return canEditCondition(ScopeType.WHOLESALER);
        default:
            return true;
    }
};

export const mappedPermissions = (permissions) =>
    permissions.reduce((result, currentValue) => {
        const currentValueName = addSpacing(currentValue.name);
        if (!result[currentValueName]) {
            result[currentValueName] = {
                [currentValue.scope]: currentValue,
            };
            return result;
        }
        result[currentValueName][currentValue.scope] = currentValue;
        return result;
    }, {});
